import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';

const states: Ng1StateDeclaration[] = [{
    name: 'notFound',
    url: '/notFound',
    template: require('./notFound.html'),
    abstract: false,
    resolve: {
        auth: Resolve.authResolve,
    },
    params: {
        index: ''
    },
    data: {
        visible: false,
        displayName: 'Not found',
        editButtonVisibility: () => false,
        ignoreHistory: true
    }
}];

export default states;
